import React, {useState} from 'react';
import {View, StyleSheet} from 'react-native';

import {makeStyles, Tab} from 'react-native-elements'; // rne-netzon replaced

import {useDebounce} from '../../hooks/debounce/useDebounce';

import {AdminPatientVerifiedTab, AdminSearchHeader} from '../../views';

const AdminPatientsScreen = () => {

  const [searchValue, setSearchValue] = useState('');

  const debouncedSearchValue = useDebounce(searchValue, 350);

  const onFilterClick = () => {};
  const onExportClick = () => {};

  return (
    <View style={styles.rootContainer}>
      <AdminSearchHeader
        title="Patient Accounts"
        searchValue={searchValue}
        onSearchValueChange={setSearchValue}
        onFilterClick={onFilterClick}
        onExportClick={onExportClick}
      />

      <View style={styles.tabsContentContainer}>
        <AdminPatientVerifiedTab searchKey={debouncedSearchValue} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  rootContainer: {
    height: '100%',
    paddingVertical: 120,
    paddingHorizontal: 72,
  },
  tabsContentContainer: {
    marginTop: 32,
    height: '100%',
  },
});

export default AdminPatientsScreen;
